/**
 * @flow
 * @relayHash 3d46af01314462810c7313a2744aae26
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
export type checkoutDeletePromoCode_MutationVariables = {|
  input: {
    clientMutationId?: ?string,
  },
  country_code?: ?string,
  subdivision_code?: ?string,
|};
export type checkoutDeletePromoCode_MutationResponse = {|
  +deletePromoCode: ?{|
    +checkout: ?{|
      +id: string,
      +currency_code: ?string,
      +currency_rate: ?number,
      +discount: ?number,
      +invoice_number: ?number,
      +order_date: ?any,
      +payment_due_date: ?any,
      +payment_received_date: ?any,
      +payment_status: ?OrderPaymentStatus,
      +subtotal: ?number,
      +total: ?number,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +general_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +description: ?string,
        +amount: ?number,
        +discount_amount: ?number,
      |}>,
      +promo_code_line_item: ?{|
        +id: string,
        +code: ?string,
        +discount_type: ?PromoCodeDiscountType,
        +discount_type_amount: ?number,
      |},
      +tax_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +priority: ?number,
        +tax_name: ?string,
        +rate: ?number,
        +amount: ?number,
      |}>,
      +licensee_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +billing_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +project_details: ?{|
        +brand: ?string,
        +product: ?string,
        +reference: ?string,
        +po_number: ?string,
        +notes: ?string,
      |},
      +authorized_representative: ?{|
        +name: ?string,
        +email: ?string,
        +phone: ?string,
        +role_id: ?string,
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
      |},
    |},
  |},
|};
*/


/*
mutation checkoutDeletePromoCode_Mutation(
  $input: DeletePromoCodeInput!
  $country_code: String
  $subdivision_code: String
) {
  deletePromoCode(input: $input) {
    checkout(country_code: $country_code, subdivision_code: $subdivision_code) {
      id
      currency_code
      currency_rate
      discount
      invoice_number
      order_date
      payment_due_date
      payment_received_date
      payment_status
      subtotal
      total
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      general_line_items {
        id
        description
        amount
        discount_amount
      }
      promo_code_line_item {
        id
        code
        discount_type
        discount_type_amount
      }
      tax_line_items {
        id
        priority
        tax_name
        rate
        amount
      }
      licensee_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      billing_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      project_details {
        brand
        product
        reference
        po_number
        notes
      }
      authorized_representative {
        name
        email
        phone
        role_id
        role {
          id
          name
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePromoCodeInput!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "country_code",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "subdivision_code",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discount_amount",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v6,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v9 = [
  v1,
  v8
],
v10 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  },
  v1,
  v8,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v9
  },
  v6,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }
],
v11 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePromoCode",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeletePromoCodeInput!"
      }
    ],
    "concreteType": "DeletePromoCodePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "checkout",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "country_code",
            "variableName": "country_code",
            "type": "String"
          },
          {
            "kind": "Variable",
            "name": "subdivision_code",
            "variableName": "subdivision_code",
            "type": "String"
          }
        ],
        "concreteType": "Order",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "subtotal",
            "args": null,
            "storageKey": null
          },
          v1,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency_rate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "discount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "invoice_number",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "order_date",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_due_date",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_received_date",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency_code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseLineItem",
            "plural": true,
            "selections": [
              v1,
              v2,
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "track",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [
                  v1,
                  v4,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "added_to_cart",
                    "args": null,
                    "storageKey": null
                  },
                  v5,
                  v7,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "artist",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Artist",
                    "plural": false,
                    "selections": [
                      v1,
                      v8,
                      v5,
                      v7
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "terms",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTermConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TaxonomyTermEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TaxonomyTerm",
                            "plural": false,
                            "selections": [
                              v1,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "is_highlighted",
                                "args": null,
                                "storageKey": null
                              },
                              v8,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "parent_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "taxonomy",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Taxonomy",
                                "plural": false,
                                "selections": [
                                  v1,
                                  v4,
                                  v8
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "license",
                "storageKey": null,
                "args": null,
                "concreteType": "StandardLicense",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StandardLicenseUsage",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "license_id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "air_date",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "components",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StandardLicenseUsageComponent",
                        "plural": true,
                        "selections": [
                          v1,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "component_id",
                            "args": null,
                            "storageKey": null
                          },
                          v8,
                          v6
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "general_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "GeneralLineItem",
            "plural": true,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              v2,
              v3
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "promo_code_line_item",
            "storageKey": null,
            "args": null,
            "concreteType": "PromoCodeLineItem",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discount_type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discount_type_amount",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tax_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxLineItem",
            "plural": true,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "priority",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "tax_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rate",
                "args": null,
                "storageKey": null
              },
              v2
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "licensee_address",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderAddress",
            "plural": false,
            "selections": v10
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "billing_address",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderAddress",
            "plural": false,
            "selections": v10
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "project_details",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectDetails",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "product",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "reference",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "po_number",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "authorized_representative",
            "storageKey": null,
            "args": null,
            "concreteType": "AuthorizedRepresentative",
            "plural": false,
            "selections": [
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "role_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "role",
                "storageKey": null,
                "args": null,
                "concreteType": "RepresentativeRole",
                "plural": false,
                "selections": v9
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "checkoutDeletePromoCode_Mutation",
  "id": null,
  "text": "mutation checkoutDeletePromoCode_Mutation(\n  $input: DeletePromoCodeInput!\n  $country_code: String\n  $subdivision_code: String\n) {\n  deletePromoCode(input: $input) {\n    checkout(country_code: $country_code, subdivision_code: $subdivision_code) {\n      id\n      currency_code\n      currency_rate\n      discount\n      invoice_number\n      order_date\n      payment_due_date\n      payment_received_date\n      payment_status\n      subtotal\n      total\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      general_line_items {\n        id\n        description\n        amount\n        discount_amount\n      }\n      promo_code_line_item {\n        id\n        code\n        discount_type\n        discount_type_amount\n      }\n      tax_line_items {\n        id\n        priority\n        tax_name\n        rate\n        amount\n      }\n      licensee_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      billing_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      project_details {\n        brand\n        product\n        reference\n        po_number\n        notes\n      }\n      authorized_representative {\n        name\n        email\n        phone\n        role_id\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "checkoutDeletePromoCode_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v11
  },
  "operation": {
    "kind": "Operation",
    "name": "checkoutDeletePromoCode_Mutation",
    "argumentDefinitions": v0,
    "selections": v11
  }
};
})();
(node/*: any*/).hash = '54484882fddcb0f4bbcc54e901e28e1b';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/checkoutDeletePromoCode_Mutation.graphql.js